import { lazy, Suspense } from 'react';

// project imports
import MainLayout from 'layout/MainLayout';
import Loadable from 'ui-component/Loadable';
import PopularServices from 'views/utilities/PopularServices';
import Circular from 'utils/Loader';
import LimitLayout from 'views/utilities/LimitManagement';
import AddMoneyLayout from 'views/utilities/AddMoney';
import AccountRegistration from 'views/utilities/AccountRegistration';
import SBI_Limit_layout from 'views/utilities/SBI_limit_request';
//  import MoneyTransfer from 'views/utilities/MoneyTransfer';

const AuthTok = sessionStorage.getItem("UserToken")
// dashboard routing
const DashboardDefault = Loadable(lazy(() => import('views/dashboard/Default')));
const AgentProduct = Loadable(lazy(() => import('views/dashboard/Default/AgentProduct')));
const AgentProductForm = Loadable(lazy(() => import('views/dashboard/Default/AgentProduct/ProductForm')));
const TmAgentProduct = Loadable(lazy(() => import('views/utilities/TmAgentProductForm.js')));
const ProfileList = Loadable(lazy(() => import('views/utilities/ProfileList')));
const AgentSigninTm = Loadable(lazy(() => import('views/pages/AgentSignin_Link/authentication3/AgentSignin')));

// utilities routing
const UtilsTypography = Loadable(lazy(() => import('views/utilities/Typography')));
const UtilsColor = Loadable(lazy(() => import('views/utilities/Color')));
const UtilsShadow = Loadable(lazy(() => import('views/utilities/Shadow')));
const UtilsMaterialIcons = Loadable(lazy(() => import('views/utilities/MaterialIcons')));
const UtilsServicerequest = Loadable(lazy(() => import('views/utilities/RequestService/Servicerequest')));
const UtilsRequeststatus = Loadable(lazy(()=> import('views/utilities/RequestStatus')))
const UtilsAgreement = Loadable(lazy(()=> import('views/utilities/Agreement')))
const UtilsServicelist = Loadable(lazy(() => import('views/utilities/ServiceList')));
const UtilsTablerIcons = Loadable(lazy(() => import('views/utilities/TablerIcons')));
const UtilsServices = Loadable(lazy(() => import('views/utilities/MoneyTransfer')));
// const UtilsMoneyTransfer=Loadable(lazy(() => import('views/utilities/PopularServices')));
const UtilsFIServices = Loadable(lazy(() => import('views/utilities/RequestService/FIviewMore')));
const NonFiMore = Loadable(lazy(() => import('views/utilities/RequestService/NonFiMore')));
const Deboarding = Loadable(lazy(() => import('views/utilities/Components/Deboarding')));
const ProcurementDevicePurchase = Loadable(lazy(() => import('views/utilities/Procurement')));
const ProcurementDeviceList = Loadable(lazy(() => import('views/utilities/Procurement/DeviceList')));
const ProcurementOrderStatus = Loadable(lazy(() => import('views/utilities/Procurement/OrderStatus')));
const Branding = Loadable(lazy(() => import('views/utilities/Branding/Download Branding')));
const BrandingList = Loadable(lazy(() => import('views/utilities/Branding/Brandings')));

// sample page routing
const SamplePage = Loadable(lazy(() => import('views/sample-page')));

// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
  path: '/',
  element: (
    <Suspense fallback={<Circular />}>
      {<MainLayout />}
      </Suspense>
       ),
  children: [
    {
      path: '/',
      element: (
        <Suspense fallback={<Circular />}>
          {AuthTok?<AgentProduct />:null}
        </Suspense>
      )
    },

    {
      path: 'dashboard',
      children: [
        {
          path: 'default',
          element: (
            <Suspense fallback={<Circular />}>
              {AuthTok?<AgentProduct />:null}
            </Suspense>
          )
        }
      ]
    },
    {
      path: 'product',
      children: [
        {
          path: 'dashboard',
          element: (
            <Suspense fallback={<Circular />}>
              {AuthTok?<DashboardDefault />:null}
            </Suspense>
          )
        }
      ]
    },
    {
      path: 'product',
      children: [
        {
          path: 'TmAgentProduct',
          element: (
            <Suspense fallback={<Circular />}>
              {AuthTok?<TmAgentProduct />:<AgentSigninTm/>}
            </Suspense>
          )
        }
      ]
    },
    {
      path: 'agentform',
      children: [
        {
          path: 'product/:id',
          element:(
            <Suspense fallback={<Circular />}>
               {AuthTok?<AgentProductForm />:null}
            </Suspense>
          )
        }
      ]
    },

    {
      path: 'utils',
      children: [
        {
          path: 'util-typography',
          element:  (
            <Suspense fallback={<Circular />}>
               <UtilsTypography />
            </Suspense>
          )
        }
      ]
    },
    {
      path: 'utils',
      children: [
        {
          path: 'util-color',
          element:  (
            <Suspense fallback={<Circular />}>
               <UtilsColor />
            </Suspense>
          )
        }
      ]
    },
    {
      path: 'utils',
      children: [
        {
          path: 'util-shadow',
          element: <UtilsShadow />
        }
      ]
    },
    {
      path: 'icons',
      children: [
        {
          path: 'tabler-icons',
          element:  (
            <Suspense fallback={<Circular />}>
               <UtilsTablerIcons />
            </Suspense>
          )
        }
      ]
    },
    {
      path: 'icons',
      children: [
        {
          path: 'material-icons',
          element: (
            <Suspense fallback={<Circular />}>
               <UtilsMaterialIcons />
            </Suspense>
          )
        }
      ]
    },
    {
      path: 'sample-page',
      element:  (
        <Suspense fallback={<Circular />}>
           <SamplePage />
        </Suspense>
      )
    },
    {
      path: 'dashboard',
      children: [
        {
          path: 'requeststatus',
          element: (
            <Suspense fallback={<Circular />}>
               {AuthTok?<UtilsRequeststatus />:null}
            </Suspense>
          ),
          breadcrumbs: true
        }
      ]
    },
    {
      path: 'dashboard',
      children: [
        {
          path: 'agreement',
          element: (
            <Suspense fallback={<Circular />}>
               {AuthTok?<UtilsAgreement />:null}
            </Suspense>
          ),
          breadcrumbs: true
        }
      ]
    },
    {
      path: 'dashboard',
      children: [
        {
          path: 'servicerequest',
          element: (
            <Suspense fallback={<Circular />}>
               {AuthTok?<UtilsServicerequest />:null}
            </Suspense>
          ),
          breadcrumbs: true
        }
      ]
    },
    {
      path: 'dashboard',
      children: [
        {
          path: 'Profile',
          element: (
            <Suspense fallback={<Circular />}>
               {AuthTok?<ProfileList />:null}
            </Suspense>
          ),
          breadcrumbs: true
        }
      ]
    },

    {
      path: 'dashboard',
      children: [
        {
          path: 'Servicelist',
          element:  (
            <Suspense fallback={<Circular />}>
               {AuthTok?<UtilsServicelist />:null}
            </Suspense>
          ),
          breadcrumbs: true
        }
      ]
    },
    {
      path: 'dashboard',
      children: [
        {
          path: 'Services/:id',
          element: (
            <Suspense fallback={<Circular />}>
               {AuthTok?<UtilsServices />:null}
            </Suspense>
          ),
          breadcrumbs: true
        }
      ]
    },
    {
      path: 'dashboard/Services/:id',
      children: [
        {
          path: 'MoneyTransfer',
          element:  (
            <Suspense fallback={<Circular />}>
               {AuthTok?<PopularServices />:null}
            </Suspense>
          ),
          breadcrumbs: true
        }
      ]
    },
    {
      path: 'dashboard',
      children: [
        {
          path: 'Services/FIservices',
          element:  (
            <Suspense fallback={<Circular />}>
               {AuthTok?<UtilsFIServices />:null}
            </Suspense>
          ),
          breadcrumbs: true
        }
      ]
    },
    {
      path: 'dashboard',
      children: [
        {
          path: 'Services/NONFIservices',
          element:  (
            <Suspense fallback={<Circular />}>
               {AuthTok?<NonFiMore />:null}
            </Suspense>
          ),
          breadcrumbs: true
        }
      ]
    },
    {
      path: 'dashboard',
      children: [
        {
          path: 'deboarding',
          element:  (
            <Suspense fallback={<Circular />}>
               {AuthTok?<Deboarding />:null}
            </Suspense>
          ),
          breadcrumbs: true
        }
      ]
    },

    {
      path: 'limit',
      children: [
        {
          path: 'topup',
          element:  (
            <Suspense fallback={<Circular />}>
               {AuthTok?<LimitLayout/>:null}
            </Suspense>
          ),
          breadcrumbs: true
        }
      ]
    },

    {
      path: 'limit',
      children: [
        {
          path: 'topup/:type',
          element:  (
            <Suspense fallback={<Circular />}>
               {AuthTok?<LimitLayout/>:null}
            </Suspense>
          ),
          breadcrumbs: true
        }
      ]
    },

    {
      path: 'limit',
      children: [
        {
          path: 'addmoney',
          element:  (
            <Suspense fallback={<Circular />}>
               {AuthTok?<AddMoneyLayout/>:null}
            </Suspense>
          ),
          breadcrumbs: true
        }
      ]
    },

    {
      path: 'limit',
      children: [
        {
          path: 'account_register',
          element:  (
            <Suspense fallback={<Circular />}>
               {AuthTok?<AccountRegistration/>:null}
            </Suspense>
          ),
          breadcrumbs: true
        }
      ]
    },
    {
      path: 'limit',
      children: [
        {
          path: 'sbi_kiosk',
          element:  (
            <Suspense fallback={<Circular />}>
               {<SBI_Limit_layout/>}
            </Suspense>
          ),
          breadcrumbs: true
        }
      ]
    },
    {
      path: 'Procurement',
      children: [
        {
          path: 'purchase_device',
          element:  (
            <Suspense fallback={<Circular />}>
               {<ProcurementDevicePurchase/>}
            </Suspense>
          ),
          breadcrumbs: true
        }
      ]
    },
    {
      path: 'Procurement',
      children: [
        {
          path: 'order_status',
          element:  (
            <Suspense fallback={<Circular />}>
               {<ProcurementOrderStatus/>}
            </Suspense>
          ),
          breadcrumbs: true
        }
      ]
    },
    {
      path: 'Procurement',
      children: [
        {
          path: 'device_list',
          element:  (
            <Suspense fallback={<Circular />}>
               {<ProcurementDeviceList/>}
            </Suspense>
          ),
          breadcrumbs: true
        }
      ]
    },
    {
      path:'agentform',
      children: [
        {
          path: 'product_payment/:id',
          element:  (
            <Suspense fallback={<Circular />}>
               {<SBI_Limit_layout/>}
            </Suspense>
          ),
          breadcrumbs: true
        }
      ]
    },
    {
      path:'branding',
      children: [
        {
          path: 'downloadBrand',
          element:  (
            <Suspense fallback={<Circular />}>
               {<Branding/>}
            </Suspense>
          ),
          breadcrumbs: true
        }
      ]
    },
    {
      path:'branding',
      children: [
        {
          path: 'brandlist',
          element:  (
            <Suspense fallback={<Circular />}>
               {<BrandingList/>}
            </Suspense>
          ),
          breadcrumbs: true
        }
      ]
    }
  ]
};

export default MainRoutes;
